"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.HeroBrandV2 = exports.HeroBrandDefaultProps = void 0;
var _heroBrandV = _interopRequireDefault(require("./components/hero-brand-v2"));
exports.HeroBrandV2 = _heroBrandV["default"];
var _heroBrand = _interopRequireDefault(require("./components/hero-brand.props/hero-brand.defaultProps"));
exports.HeroBrandDefaultProps = _heroBrand["default"];